import React, { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";

import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";
import axios from "axios";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Wrapper from "../components/layout/Wrapper";

import DashboardDraftTable from "../components/draft/DashboardDraftTable";

export default function DraftAdmin() {
   return (
      <Wrapper key={"draftAdmin"}>
         <Typography
            variant='h3'
            component='div'
            sx={{ textAlign: "center", textTransform: "uppercase" }}
         >
            Draft Admin
         </Typography>

         <DashboardDraftTable draftId={1} />
      </Wrapper>
   );
}
